/**
 * 恢复车辆一览模块
 * 创建人：DrugsZ
 * 创建时间：2017-09-29

 */
<template>
	<div id="recoverCar-list" class="wrapper wrapper-content fadeInRight animated tabBox" style="display: block;">
	   <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label">车辆编号</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.vehicleId" maxlength="10">
				</div>
				<label class="col-sm-1 control-label">服务卡号</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model.trim="queryParam.vehicleAccount" maxlength="20">
				</div>
				<label class="col-sm-1 control-label">车牌号</label>
				<div class="col-sm-2">
					<vplate-input type="text" class="form-control" v-model.trim="queryParam.plateNumber" maxlength="20"/>
				</div>
				<label class="col-sm-1 control-label">车辆类型</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.style">
						<option v-for="(item, index) in udcList" :value="item.udccode" :key="'styleUdc' + index">{{item.udcname}}</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">所属公司</label>
				<div class="col-sm-2">
					<!-- <input type="text" class="form-control" v-model.trim="queryParam.customerName" maxlength="20"> -->
					<input type="text" id="cargroup_list" class="form-control menuInput" v-model="queryGroup" @focus="showMenu" autocomplete="off" disableautocomplete>
					<div id="recoverCarContentOrder" class="menuContent" style="display:none; position: absolute;">
						<ul id="recoverCarGroupTree" class="ztree ztree-slide" style="margin-top:0; width:250px; height: 300px;"></ul>
					</div>
				</div>
				<label class="col-sm-1 control-label">在驾司机</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model.trim="queryParam.driverName" maxlength="20">
				</div>
				<label class="col-sm-1 control-label">服务项目</label>
				<div class="col-sm-5"  v-if="isRender">
					<div class="col-sm-2 control-label" v-for="item in service" :key="'service' + index">
						<checkbox v-model="item.type" v-if="queryParam.style!=luxiuCode||item.udcname!='拖车'">{{item.udcname}}</checkbox>
					</div>
				</div>
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button v-if="permission.indexOf('carFileList_select') == -1" class="btn btn-primary" @click="searchInfo">查询</button>
					<button v-if="permission.indexOf('carFileList_reset') == -1" class="btn btn-primary" @click="resetQueryParams">重置</button>
				</div>
			</div>
			<div class="hr-line-dashed"></div>
		</div>

		<!--表格开始-->
		<div class="table-responsive">
				<div style="overflow: auto;">
					<table class="table mb0px table-striped table-bordered table-hover" style="min-width:1600px;">
						<thead>
							<tr role="row">
								<th>车辆编号</th>
								<th>服务卡号</th>
								<th>服务结束日</th>
								<th>车牌号</th>
								<th>车辆类型</th>
								<th>载重量(吨)</th>
								<th>服务状态</th>
								<th>所属公司</th>
								<th>所在城市</th>
								<th>在驾司机</th>
								<th>司机电话</th>
								<th>服务项目</th>
								<th v-if="fileInfoList.length>0"></th>
							</tr>
						</thead>
						<transition-group name="list-complete" tag="tbody">
							<tr v-for="(fileInfo,index) in fileInfoList" v-bind:key="index + 'fileInfoCar'" class="list-complete-item">
								<td>VE{{fileInfo.vehicleId}}</td>
								<td>{{fileInfo.vehicleAccount}}</td>
								<td>{{fileInfo.serviceEndTime}}</td>
								<td>{{fileInfo.plateNumber}}</td>
								<td>{{fileInfo.styleName}}</td>
								<td>{{fileInfo.maximumLoadStr}}</td>
								<td>{{fileInfo.serverStatusName}}</td>
								<td>{{fileInfo.customerName}}</td>
								<td>{{fileInfo.city}}</td>
								<td>{{fileInfo.driverName}}</td>
								<td>{{fileInfo.driverPhone}}</td>
								<!--<td  class="text-center">{{setServiceText(fileInfo.serviceItems)}}</td>-->
								<td>{{fileInfo.serverItemName}}</td>
								<td class="text-center">
									<a @click="recoverBtn(fileInfo.vehicleId)">恢复</a>
								</td>
							</tr>
						</transition-group>
					</table>
				</div>
		</div>

		<pagination v-if="fileInfoList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
		</div>
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		<tab-modal ref="recoveConfirm" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="recoverCar" class="btn btn-primary">确定</button>
		        <button @click="closeModal('recoveConfirm')" class="btn btn-primary">取消</button>
		    </div>
		</tab-modal>
	</div>
</template>

<script>
    import Pagination from 'components/common/Pagination'
    import PageCarFileDetail from 'components/pages/carfile/PageCarFileDetail'
    import TabModal from 'components/common/TabModal'
import Datepicker from 'components/common/datepicker/Datepicker'
    import {OPERATE_EXCEPTION } from 'static/message'
    import FileUpload from 'components/common/FileUpload'
    import FileDownload from 'components/common/FileDownload'
    import SubPage from 'components/common/SubPage'
    import 'assets/plugins/ztree/css/metroStyle/metroStyle.css'
import classlist from 'util/classlist'
import Checkbox from 'components/common/Checkbox'
export default {
  name: 'PageRecoverCar',
  components: {
        Pagination,
        PageCarFileDetail,
        TabModal,
        Datepicker,
        SubPage,
        FileUpload,
        FileDownload,
        Checkbox
  },
  watch: {
        'queryParam.style': function () {
          this.service.map(item => {
            item.type = false
          })
        }
  },
  computed: {
        luxiuCode () {
          let code = ''
          this.udcList.map(item => {
            if (item.udcname == '路修车') {
              code = item.udccode
            }
          })
          return code
        }
  },
  data () {
        return {
          permission: this.$store.state.permission.permission['carFileList'] ? this.$store.state.permission.permission['carFileList'] : [],
          loadingstatus: false,
          fileInfoList: [],										// 查询结果
          pageInfo: {},											// 分页所需信息
          pageNo: 1, 												// 分页返回的当前页数
          queryParam: {											// 查询参数
            vehicleId: '',										// 车辆ID
            vehicleAccount: '',									// 服务卡号
            plateNumber: '',									// 车牌号
            style: '',											// 车辆类型
            driverName: '',										// 驾驶司机
            rescueType: '',													// 服务项目
            page_index: 1,										// 当前页码
            customerId: ''
          },
          messageStr: '',					// 弹出框内容
//				serviceArr:[
//					'',
//					'拖车',
//					'搭电',
//					'路修',
//					'送油',
//				],
          scrollTop: '0',
          service: [],
          udcList: [],
          toShow: false,
          toDownShow: false,
          bigTitle: '',
          isRender: false,
          lastId: '',
          queryGroup: '',
          groupList: [],
          setting: {
            data: {
              key: {
                name: 'name'
              },
              simpleData: {
                enable: true,
                pIdKey: 'pId'
              }
            },
            view: {
              dblClickExpand: false,
              selectedMulti: false,
              autoCancelSelected: true
            },
            callback: {
              onClick: this.onClick
            }
          }
        }
  },
  beforeMount () {
        this.getGroups()
        this.getTableInfo()
        this.getUdc()
  },
  methods: {
        handleSubPage () {
          this.toShow = false
        },
//			openFileUpload(){
//				this.bigTitle = '文件上传'
//				this.toShow = true;
//			},
        handleDownSubPage () {
          this.toDownShow = false
        },
//			openDownload(){
//				this.bigTitle = '文件下载'
//				this.toDownShow = true;
//			},
//			setServiceText(val){
//				let tempList = [];
//				val.join().map(forEach=>{
//					tempList.push(this.serviceArr[item]);
//				})
//				return tempList.join('|')
//			},
//			setStatusText(val){
//				return this.service.map(item=>item.udccode == val).udcname;
//			},
        searchInfo () {
          this.queryParam.page_index = 1
          this.getTableInfo()
        },
        strService () {
          let tempArr = []
          this.service.map(item => {
            if (item.type == true)					{
              tempArr.push(item.udccode)
            }
          })
          this.queryParam.rescueType = tempArr.join(',')
        },
        getTableInfo: function () {
          this.strService()
          this.loadingstatus = true
          let that = this
          this.groupList.map(item => {
            if (item.id == that.queryParam.customerId) {
              that.queryGroup = item.name
            }
          })
				// this.$http.get(process.env.API_ROOT + '/mockjs/41/rescue-api/vehicles?driverName=&vehicleAccount=&serviceItems=&customerId=&style=&plateNumber=&vehicleId=')
          this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/deleted/vehicles', {params: this.queryParam})
				.then(res => {
  if (res.body.success) {
        const {pageNum, pages, total, isFirstPage, isLastPage} = res.body.data
        this.pageInfo = {
          pageNum: pageNum,
          pages: pages,
          total: total,
          isFirstPage: isFirstPage,
          isLastPage: isLastPage
        }
        this.fileInfoList = res.body.data.list
        this.fileInfoList.map(item => {
          if (item.serviceEndTime != '' && item.serviceEndTime != null) {
            item.serviceEndTime = item.serviceEndTime.slice(0, 10)
          }
        })
  } else {
        this.openModalMsg(res.body.message)
  }
  this.loadingstatus = false
}, res => {
  this.loadingstatus = false
  this.openModalMsg(res.body.message)
}).catch(res => {
  this.loadingstatus = false
  this.openModalMsg(OPERATE_EXCEPTION)
})
        },
//			getUdc(){
//				this.$http.get(process.env.API_ROOT+'/system/udcs/license/2?udcTypes=STYLE')
//				.then(res=>{
//					if(res.body.success){
//						this.udcList = res.body.data.STYLE;
//					}else{
//						this.openModalMsg(res.body.message);
//					}
//				},res=>{
//					this.openModalMsg(res.body.message);
//				}).catch(res=>{
//					this.openModalMsg(res.body.message);
//				})
//			},
			// 从分页组件获取页码参数
        getPageNo (pageNo) {
          this.pageNo = pageNo
          this.queryParam.page_index = pageNo
          this.getTableInfo()
        },
        resetQueryParams: function () {
          this.queryParam.vehicleId = '',
				this.queryParam.vehicleAccount = '',
				this.queryParam.plateNumber = '',
				this.queryParam.style = '',
				this.queryParam.customerName = '',
				this.queryParam.driverName = '',
				this.queryParam.page_index = '',
				this.service.map(item => {
  item.type = false
})
          this.queryParam.customerId = ''
          this.queryGroup = ''
        },
			// 消息弹出框相关
        openModal (ref) {
            	this.$refs[ref].open()
        	classlist.toggleScroll('close', '#recoverCar-list', this)
        },
        	closeModal (ref) {
        		this.$refs[ref].close()
          classlist.toggleScroll('open', '#recoverCar-list', this)
        },
        	closeModalMsg () {
        		this.closeModal('modalMsg')
        },
        	openModalMsg (message) {
        		this.messageStr = message
          this.openModal('modalMsg')
        	},
        	recoverBtn (id) {
        		this.messageStr = '是否确认恢复该车辆？'
          this.openModal('recoveConfirm')
          this.lastId = id
        	},
        	recoverCar: function () {
        		this.closeModal('recoveConfirm')
        		this.loadingstatus = true
          this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/vehicles/' + this.lastId + '/recovery')
					.then(res => {
  if (res.body.success) {
        this.openModalMsg('操作成功')
        this.getTableInfo()
  } else {
        this.openModalMsg(res.body.message)
  }
  this.loadingstatua = false
}, res => {
  this.loadingstatus = false
  this.openModalMsg(res.body.message)
}).catch(res => {
  this.loadingstatus = false
  this.openModalMsg(res.body.message)
})
        },
        getUdc () {
//				let udcType = ['RESCUE_TYPE','STYLE']
//				let param = udcType.join(',');
          this.$http.get(process.env.API_ROOT + '/system/udcs/license/2', {params: {udcTypes: 'RESCUE_TYPE,STYLE' }, headers: this.token})
				.then(res => {
  if (res.body.success) {
        let obj = res.body.data
        for (let k of obj.RESCUE_TYPE) {
          k.type = false
          this.service.push(k)
        }
        for (let k of obj.STYLE) {
          this.udcList.push(k)
        }
					 	let tempObj = {
					 		udccode: '',
					 		udcname: '全部'
					 	}
					 	this.udcList.unshift(tempObj)
					 	this.isRender = true
  } else {
        this.openModalMsg(res.body.message)
  }
}, res => {
  this.openModalMsg(res.body.message)
  if (res.body.message == '') {
        this.openModalMsg('请求出问题啦')
  }
}).catch(res => {
  this.openModalMsg('请求异常')
})
        },
        showMenu () {
          $('.menuContent').slideDown('fast')
          $('body').bind('mousedown', this.onBodyDown)
        },
        onBodyDown (event) {
          var self = this
          if (!(event.target.id == 'recoverCarGroupTree' || event.target.id == 'recoverCarContentOrder' || $(event.target).parents('.menuContent').length > 0)) {
            this.hideMenu()
          }
        },
        hideMenu () {
          $('.menuContent').fadeOut('fast')
          $('body').unbind('mousedown', this.onBodyDown)
        },
			// z-tree 相关
        treeInit () { // 初始化z-tree树
          $.fn.zTree.init($('#recoverCarGroupTree'), this.setting, this.groupList)
          this.$nextTick(() => {
            this.zTreeNodes = $.fn.zTree.getZTreeObj('recoverCarGroupTree').getNodes()
            $.fn.zTree.getZTreeObj('recoverCarGroupTree').expandAll(true)
            this.queryGroup = this.zTreeNodes[0].name
          })
        },
        onClick (e, treeId, treeNode) { // 点击树节点
          this.queryParam.customerId = treeNode.id
          this.queryParam.customerName = treeNode.name
          this.queryGroup = treeNode.name
        },
			// getRoot() {
			//    let treeObj = $.fn.zTree.getZTreeObj("recoverCarGroupTree");
			//     //返回一个根节点
			//    let node = treeObj.getNodesByFilter(function (node) { return node.level == 0 }, true);
			//    this.queryGroup=node.name;
			//    this.queryParam.customerId=node.id;
			// },
        getGroups: function () {
          this.loadingstatus = true
          this.$http.get(process.env.API_ROOT + '/monitor/tree/groups?showTreeType=1')
				.then(res => {
  if (res.body.success) {
						// })
        let resInfo = res.body.data
        this.groupList = resInfo
        this.treeInit()
						// this.getRoot();
  } else {
        this.openModalMsg(res.body.message)
  }
  this.loadingstatus = false
}, res => {
  this.openModalMsg(res.body.message)
  this.loadingstatus = false
}).catch(res => {
  this.openModalMsg(OPERATE_EXCEPTION)
  this.loadingstatus = false
})
        }
  }
}
</script>
<style scoped>
.menuInput{
		position:relative;
	}
	.menuContent{
		position:absolute;
		top:31px;
		left:6px;
		border:1px solid #ddd;
		z-index:999;

	}
</style>



// WEBPACK FOOTER //
// PageRecoverCar.vue?1565d10d